import React, { useCallback, useEffect, useState } from 'react';

import { SignInVariant } from 'features/authentication/SignIn/constants';
import { ErrorTrackingProps } from 'features/authentication/SignIn/types';

import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useExtendUx, useTrackUx } from 'util/uxEvents';

import EmailSignIn from './EmailSignIn';
import PhoneSignIn from './PhoneSignIn';

type Props = {
  onSuccess: () => void;
} & ErrorTrackingProps;
const SignInContainer = ({ onError, onSuccess }: Props) => {
  const [signInType, setSignInType] = useState(SignInVariant.EMAIL);
  const trackUx = useTrackUx();
  const extendUx = useExtendUx();

  extendUx({
    view: signInType,
  });

  useEffect(() => {
    trackUx(EVENT_ACTIONS.PAGE_VIEWED, TRACK_ACTION_TYPES.VIEW);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSignInType = useCallback(
    (view: SignInVariant) => setSignInType(view),
    []
  );

  return signInType === SignInVariant.EMAIL ? (
    <EmailSignIn
      onChangeSignInType={handleChangeSignInType}
      onError={onError}
      onSuccess={onSuccess}
    />
  ) : (
    <PhoneSignIn
      onChangeSignInType={handleChangeSignInType}
      onError={onError}
      onSuccess={onSuccess}
    />
  );
};

export default SignInContainer;
